/**
 * Spacing tokens — brand-guide.md v0.2.2 §6.4
 *
 * `4 · 8 · 12 · 16 · 20 · 24 · 32 · 48 · 64 · 96` (px)
 */
export const spacing = {
    0: '0',
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    8: '32px',
    12: '48px',
    16: '64px',
    24: '96px',
};
/**
 * Touch target minimum — WCAG 2.2 SC 2.5.8 target size.
 * Contract C11 asserts every interactive element clears this on `pointer: coarse`.
 */
export const minTouchTargetPx = 44;
//# sourceMappingURL=spacing.js.map